import { PARAM_DEX } from '@/constants/paramList'
import { creatureCollection } from '@/constants/creatureList'

import calcAc from '@/utils/calcAc'

export default ({ creatureId, armorId }) => calcAc({
  dex: creatureCollection[creatureId].params[PARAM_DEX],
  armorId,
})
